export const eventsEnum = {
    POSTED_JOB_POSTS: 'POSTED_JOB_POSTS',
    STARTED_JOB_POSTS: 'STARTED_JOB_POSTS',
    JOB_POST_CLICKED: 'JOB_POST_CLICKED',
    ACTIVE_USERS: 'ACTIVE_USERS',
};
